<sdps-datepicker style="all: initial" sdps-id="sm-default-datepicker" id="{{id}}" size="small" class="sdps-m-top_large"
  [disableWeekends]="disableWeekends" (sdpsChange)="onValueChange()" (sdpsInput)="onValueChange()" [disabled]="disableDateSelect"
  (keydown)="validationService.validateNumberInput($event, datepickerAllowedChars)" (keyup)="validateDateInputLength()">
  <span slot="datepicker-custom-label">{{label}}<span class="sdps-sr-only">Type date using the format</span>
    <span *ngIf="showOptionalLabel; else elseBlock" aria-hidden="true" class="sdps-form-element__label-help">(mm/dd/yyyy
      optional)</span>
      <ng-template #elseBlock><span aria-hidden="true" class="sdps-form-element__label-help">(mm/dd/yyyy)</span>
    </ng-template>
    <span class="sdps-sr-only">m m / d d / y y y y</span>
    <mm-tooltip *ngIf="tooltip" [position]="tooltip.position" [containsLink]="tooltip.containsLink">
      <tooltip-content>
        <div *ngIf="!showIntlWireTooltip">{{tooltip.content}}</div>
        <div *ngIf="showIntlWireTooltip" class="small-bottom-spacer" data-testid="intl-tooltip-msg" [innerText]="intlWireTooltipMsg"></div>
      </tooltip-content>
      <tooltip-trigger-element>
        <sdps-icon color="active" type="functional" name="info" size="small"></sdps-icon>
      </tooltip-trigger-element>
    </mm-tooltip></span>
</sdps-datepicker>
